import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import NavigationPage from "./NavigationPage";
import GatewayPage from "./gateway/GatewayPage";
import MerchantPage from "./merchant/MerchantPage";
import TerminalPage from "./terminal/TerminalPage";
import SubscriptionValidationPage from "./subscriptionValidation/SubscriptionValidationPage";
import ServiceViewPage from "./serviceView/ServiceViewPage";
import PrintReceiptsPage from "./printReceipts/PrintReceiptsPage";

import BadRequest from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/BadRequest";
import Unauthorized from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/Unauthorized";
import NotFound from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/NotFound";
import InternalError from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/InternalError";

import SessionTimeout from "./common/error/SessionTimeout";
import SessionTimeoutAdmin from "./common/error/SessionTimeoutAdmin";
import SessionTimeoutCashiering from "./common/error/SessionTimeoutCashiering";
import CardOnFilePage from "./cardOnFile/CardOnFilePage";

const OnePayAdmin = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={NavigationPage} />
        <Route exact path="/cashieringOperations" component={NavigationPage} />
        <Route exact path="/gateways" component={GatewayPage} />
        <Route exact path="/merchants" component={MerchantPage} />
        <Route exact path="/terminals" component={TerminalPage} />
        <Route exact path="/admin" component={SubscriptionValidationPage} />
        <Route exact path="/serviceView" component={ServiceViewPage} />
        <Route exact path="/printReceipts" component={PrintReceiptsPage} />
        <Route exact path="/cardOnFile" component={CardOnFilePage} />
        <Route exact path="/bad-request" component={BadRequest} />
        <Route exact path="/unauthorized" component={Unauthorized} />
        <Route exact path="/internal-server-error" component={InternalError} />
        <Route exact path="/session-timeout" component={SessionTimeout} />
        <Route
          exact
          path="/session-timeout-admin"
          component={SessionTimeoutAdmin}
        />
        <Route
          exact
          path="/session-timeout-cashiering"
          component={SessionTimeoutCashiering}
        />
        <Route exact path="/*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default OnePayAdmin;
